<template>
  <router-view/>
</template>

<script>
import store from '@/store'

export default {
  name: 'ABReport',
  beforeRouteEnter (to, from, next) {
    const aid = to.params.aid

    store.dispatch('storeABList', aid).then(() => {
      next()
    }).catch(err => {
      next(err)
    })
  }
}
</script>

<style>

</style>
